// extracted by mini-css-extract-plugin
export default {"companyLogo":"company-logo_companyLogo__yArwO","logo":"company-logo_logo__xMJBJ","text":"company-logo_text__QYjTJ"};